import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Media from 'react-media'

import code from '@/images/code-snippet@1x.png'
import code2x from '@/images/code-snippet@2x.png'
import sdkLogoImg from '@/images/sdk_logo.gif'
import ShapesImage from '@/images/shapes/intro.svg'

import IosLogo from '../../icons/ios'
import AndroidLogo from '../../icons/android'
import { mobile, desktop } from '../../utils/media-query'
import GradientLink from '../../shared/gradient-link'
import Shapes from '../shapes'
import WebSDKLogo from '../../icons/web-sdk-logo'
import { containerWidth } from '../../constants'

const SDKLogo = styled.img`
  width: 400px;
  ${mobile.css`
        width: 260px;
    `}
`

const Blurb = styled.div`
  text-align: center;
  height: 120px;
  text-align: center;
  margin-bottom: 50px;
  max-width: 800px;

  p {
    font-size: 20px;
    line-height: 28px;

    b {
      font-weight: bold;
    }
  }

  ${mobile.css`
        width: 100%;
        height: 100%;
        margin-bottom: 20px;
    `}
`

const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${mobile.css`
        flex-direction: column;
        align-items: flex-start;
    `}
`

const Graphic = styled.img`
  margin-right: 40px;
  display: block;
  max-width: 755px;
  object-fit: contain;
  ${mobile.css`
        margin: 0;
        width: 540px;
    `};
`

const MobileDocs = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 340px;
  min-width: 200px;
  justify-content: center;
  flex: 1;

  ${mobile.css`
        margin-top: 75px;
        width: 100%;
    `}
`

const Title = styled.h3`
  opacity: 1;
  margin: 0 0 15px;
`

const Links = styled.div`
  display: flex;
  flex-direction: column;
`

const Link = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  a {
    margin-left: 10px;
  }
`

const StyledShapes = styled(Shapes)`
  top: initial;
  left: initial;
  transform: translateY(20px);
  height: 150%;

  &::before {
    background-position-y: 0;
  }
`

const CodeExampleContainer = styled.div`
  ${mobile.css`
        margin: 0;
        max-width: 100vw;
        overflow: hidden;
    `};
`

const Section = styled.section`
  ${desktop.css`
        width: ${containerWidth}px;
        margin: auto;
        height: 800px;
    `}
`

const CodeExample = () => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  return (
    <Media query={mobile.query}>
      {(matches) => <Graphic src={mounted ? (matches ? code : code2x) : ''} />}
    </Media>
  )
}

const Intro = () => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  return (
    <Section>
      {
        <Media query={mobile.query}>
          {mounted
            ? (matches) => (
                <>
                  {!matches && <StyledShapes source={ShapesImage} />}
                  <SDKLogo src={sdkLogoImg} />
                  <Blurb>
                    <p>
                      It’s never been faster or easier to bring the full <b>GIPHY</b> experience to
                      your audience. Built with developers and product designers in mind; our SDK is
                      the solution for incorporating GIFs, stickers, and exclusive content like
                      GIPHY Text and Emoji into your next app or website.
                    </p>
                  </Blurb>
                  {matches ? (
                    <>
                      <CodeExampleContainer>
                        <CodeExample />
                      </CodeExampleContainer>
                      <Info>
                        <MobileDocs>
                          <Title>iOS, Android, & Web Support</Title>
                          <p>
                            It’s never been faster or easier to bring the full <b>GIPHY</b>{' '}
                            experience to your audience. Built with developers and product designers
                            in mind; our SDK is the solution for incorporating GIFs, stickers, and
                            exclusive content like GIPHY Text and Emoji into your next app or
                            website.
                          </p>
                          <Links>
                            <Link>
                              <IosLogo /> <GradientLink text="Open iOS Docs" url="/docs/sdk#ios" />
                            </Link>
                            <Link>
                              <AndroidLogo />
                              <GradientLink text="Open Android Docs" url="/docs/sdk#android" />
                            </Link>
                            <Link>
                              <WebSDKLogo />
                              <GradientLink text="Open Web Docs" url="/docs/sdk#web" />
                            </Link>
                          </Links>
                        </MobileDocs>
                      </Info>
                    </>
                  ) : (
                    <Info>
                      <CodeExampleContainer>
                        <CodeExample />
                      </CodeExampleContainer>
                      <MobileDocs>
                        <Title>iOS, Android, & Web Support</Title>
                        <p>
                          Whether you’re building for iOS, Android, or Web, we’ve got you covered.
                          GIPHY SDK works cross platform with sample code and example apps to make
                          implementation fast and easy.
                        </p>
                        <Links>
                          <Link>
                            <IosLogo /> <GradientLink text="Open iOS Docs" url="/docs/sdk#ios" />
                          </Link>
                          <Link>
                            <AndroidLogo />
                            <GradientLink text="Open Android Docs" url="/docs/sdk#android" />
                          </Link>
                          <Link>
                            <WebSDKLogo />
                            <GradientLink text="Open Web Docs" url="/docs/sdk#web" />
                          </Link>
                        </Links>
                      </MobileDocs>
                    </Info>
                  )}
                </>
              )
            : null}
        </Media>
      }
    </Section>
  )
}

export default Intro
